import { Cog6ToothIcon } from "@heroicons/react/24/outline";
import { Trans, useLingui } from "@lingui/react/macro";

import { useAppRouter } from "~/hook/base/useAppRouter.ts";
import { BACKDROP_ANIMATION_DURATION } from "~/ui/base/Backdrop";
import { createDraggableSheet } from "~/ui/base/DraggableSheet";

export const MenuSheet = createDraggableSheet(({ close, titleId }) => {
  const { push } = useAppRouter();
  const { t } = useLingui();
  return (
    <div className="p-6 pt-0">
      <h2
        className="border-b border-zinc-100 pt-4 pb-6 text-lg font-semibold text-zinc-800 dark:border-zinc-800 dark:text-zinc-100"
        id={titleId}
      >
        <Trans>메뉴</Trans>
      </h2>
      <nav aria-label={t`메뉴 목록`} className="flex flex-col gap-4 pt-6">
        <button
          className="flex items-center text-zinc-800 dark:text-zinc-100"
          onClick={() => {
            close();
            setTimeout(() => {
              push({ pathname: "/setting" });
            }, BACKDROP_ANIMATION_DURATION);
          }}
          type="button"
        >
          <Cog6ToothIcon className="size-6" />
          <span className="ml-3 font-semibold">
            <Trans>설정</Trans>
          </span>
        </button>
      </nav>
    </div>
  );
});
